{
  "title": "Overview",
  "greeting": "Hello, {{name}}",
  "description": "Your phones and messages at a glance.",
  "actions": {
    "label": "Needs attention",
    "offlineDevices": "Offline phones",
    "offlineDevicesHint": "Enabled but not heard from",
    "failed24h": "Failed in 24 h",
    "failed24hHint": "Messages that did not go out",
    "pendingTopups": "Pending top-ups",
    "pendingTopupsHint": "Waiting for the payment",
    "wallet": "Wallet balance",
    "walletExpiry": "Next expiry on {{date}}",
    "walletNoExpiry": "Nothing expires soon",
    "walletLow": "Below your alert threshold"
  },
  "usage": {
    "title": "Plan usage",
    "plan": "{{name}} plan",
    "today": "Today",
    "month": "This month",
    "used": "{{used}} of {{limit}}",
    "usedUnlimited": "{{used}} sent",
    "unlimited": "Unlimited",
    "renews": "Renews on {{date}}",
    "ends": "Ends on {{date}}",
    "buyMore": "Buy more",
    "changePlan": "Change plan"
  },
  "figures": {
    "title": "Messages",
    "against": "vs the previous period",
    "sent": "Sent",
    "deliveryRate": "Delivery rate",
    "failed": "Failed",
    "received": "Received",
    "empty": "No messages in this period."
  },
  "breakdown": {
    "title": "Delivery status",
    "delivered": "Delivered",
    "failed": "Failed",
    "notFinal": "Not final yet",
    "notFinalHint": "Sent, with no delivery report yet",
    "empty": "Nothing sent in this period."
  },
  "devices": {
    "title": "Busiest phones",
    "all": "All phones",
    "empty": "Add your first phone",
    "emptyBody": "Install the app on an Android phone and it will send your SMS.",
    "add": "Add a phone",
    "traffic": "{{sent}} sent · {{received}} received",
    "lastSeen": "Heard from {{when}}",
    "never": "Never heard from"
  },
  "getStarted": {
    "title": "Get started",
    "body": "Three steps to your first SMS.",
    "device": "Connect a phone",
    "key": "Create an API key",
    "message": "Send your first SMS",
    "done": "Done",
    "todo": "To do"
  },
  "traffic": {
    "title": "Traffic",
    "view": "View",
    "chart": "Chart",
    "table": "Table",
    "sent": "Sent",
    "received": "Received",
    "previous": "Previous period",
    "previousDay": "Previous period: {{sent}} sent · {{received}} received",
    "previousSent": "Sent before",
    "previousReceived": "Received before",
    "day": "Day",
    "label": "{{sent}} sent and {{received}} received between {{from}} and {{to}}.",
    "empty": "No messages in this period."
  }
}
